<template>
  <div class="main">
    <base-card v-for="side in sides" :key="side.name">
      <v-card-title>{{ side.name }}</v-card-title>
      <v-card-actions class="flex text-right"><v-spacer></v-spacer>{{ side.price }}</v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sides: [
        {
          name: "Fries",
          price: "60/80 den.",
        },
        {
          name: "Sour cream",
          price: "20/30 den.",
        },
        {
          name: "Mushrooms",
          price: "30/40 den.",
        },
        {
          name: "Cheese",
          price: "30/40 den.",
        },
        {
          name: "Chicken ham",
          price: "30/40 den.",
        },
        {
          name: "Burger bun",
          price: "30 den.",
        },
        {
          name: "Kulen",
          price: "60 den.",
        },
        {
          name: "Smoked ham",
          price: "60 den.",
        },
        {
          name: "Burger patty",
          price: "100 den.",
        },
        {
          name: "Chicken breast",
          price: "110 den.",
        },
        {
          name: "Separated",
          price: "30 den.",
        },
        {
          name: "Cesar dressing",
          price: "20 den.",
        },
        {
          name: "Cutlery",
          price: "10 den.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 200vh;
  background: transparent;
}
</style>
